<template>
  <SimpleCollection
    v-if="collectionLoaded"
    class="mx-0"
    :url="'/collection/' + currentCollection.id"
    :title="collectionTitle"
    :items="items"
  />
</template>

<script>
import Vue from 'vue'
import { mapGetters, mapActions } from 'vuex'
import SimpleCollection from '@/components/SimpleCollection.vue'

export default Vue.extend({
  name: 'UserProfileSubscribedUserProductsHistory',
  components: {
    SimpleCollection
  },
  props: {
    configurations: {
      type: Object,
      default: () => {}
    },
    title: {
      type: String,
      default: ''
    }
  },
  computed: {
    ...mapGetters({
      collection: 'productCatalog/collection'
    }),
    collectionLoaded () {
      return (
        this.currentCollection !== null &&
        this.currentCollection.products.length > 0
      )
    },
    currentCollection () {
      return this.collection(this.configurations.id)
    },
    items () {
      return this.currentCollection.products.map(value => {
        return {
          title: value.name,
          imageUrl: value.icon,
          targetUrl: '/product/' + value.id,
          genre: value.genres.map(g => { return g.name }).join(', ')
        }
      })
    },
    collectionTitle () {
      if (this.title === '' || this.title === undefined) { return this.currentCollection.name }
      return this.title
    }
  },
  created () {
    if (this.currentCollection === null) {
      this.loadCollection(this.configurations.id)
    } else if (this.currentCollection.products.length === 0) {
      this.loadCollectionProducts(this.configurations.id)
    }
  },
  methods: {
    ...mapActions({
      loadCollection: 'productCatalog/loadCollection',
      loadCollectionProducts: 'productCatalog/loadCollectionProducts'
    })
  }
})
</script>
